import { ShareScreen } from "../../features/observer";

/** FS-01-05 관찰자 진입(공유 링크 재생) — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/observer */
export default function SharePage() {
  return <ShareScreen />;
}
